/**
 * Azerbaijani mobile number handling, shared by every surface that asks for one.
 *
 * These lived inside the sign-in page. Password recovery needs exactly the same
 * parsing, masking and formatting, and a second copy is how two screens start
 * disagreeing about what a valid number looks like.
 */
export const AZ_PREFIX = "+994";

export function localPhoneDigits(value) {
  let digits = String(value || "").replace(/\D/g, "");
  if (digits.startsWith("994")) digits = digits.slice(3);
  if (digits.startsWith("0")) digits = digits.slice(1);
  return digits.slice(0, 9);
}

export function formatLocalPhone(value) {
  const digits = localPhoneDigits(value);
  const parts = [];
  if (digits.slice(0, 2)) parts.push(`(${digits.slice(0, 2)}`);
  if (digits.length >= 2) parts[0] = `(${digits.slice(0, 2)})`;
  if (digits.slice(2, 5)) parts.push(digits.slice(2, 5));
  if (digits.slice(5, 7)) parts.push(digits.slice(5, 7));
  if (digits.slice(7, 9)) parts.push(digits.slice(7, 9));
  return parts.join(" ");
}

export function e164Phone(digits) {
  const local = localPhoneDigits(digits);
  return local.length === 9 ? `${AZ_PREFIX}${local}` : "";
}

/** True once the nine national digits are all there. */
export function isCompletePhone(value) {
  return localPhoneDigits(value).length === 9;
}

export function maskedPhone(phone) {
  const digits = localPhoneDigits(phone);
  if (digits.length < 4) return `${AZ_PREFIX} ${formatLocalPhone(digits)}`;
  return `${AZ_PREFIX} ${digits.slice(0, 2)} ••• •• ${digits.slice(-2)}`;
}

export function onlyOtpDigits(value) {
  return String(value || "").replace(/\D/g, "").slice(0, 6);
}

export function formatOtpTimer(seconds) {
  const total = Math.max(0, Number(seconds) || 0);
  const m = String(Math.floor(total / 60)).padStart(2, "0");
  const s = String(total % 60).padStart(2, "0");
  return `${m}:${s}`;
}
